import { useCallback } from "react";
import useAxios from "@Apis/useAxios";
import {
	POST_CYCLE_PURCHASE_OVERVIEW_API,
	GET_CYCLE_PURCHASE_OVERVIEW_OPTIONS_API,
	GET_CYCLE_PURCHASE_DETAIL_API,
	GET_CYCLE_PURCHASE_DETAIL_HISTORY_API,
	GET_CYCLE_PURCHASE_DETAIL_FUTURE_API,
	GET_CYCLE_PURCHASE_DETAIL_EFFECT_API,
	GET_CYCLE_PURCHASE_DETAIL_PDF_API,
	GET_CYCLE_PURCHASE_DETAIL_PDF_EFFECT_API,
} from "@Apis/apiPath";

const useCyclePurchaseOverviewApi = () => {
	const Axios = useAxios();

	const postCyclePurchaseOverviewApi = useCallback(
		async params => {
			return await Axios.post(POST_CYCLE_PURCHASE_OVERVIEW_API, params);
		},
		// eslint-disable-next-line
		[]
	);

	const getCyclePurchaseOverviewOptionsApi = useCallback(
		async params => {
			return await Axios.get(GET_CYCLE_PURCHASE_OVERVIEW_OPTIONS_API, params);
		},
		// eslint-disable-next-line
		[]
	);


	const getCyclePurchaseDetailApi = useCallback(
		async cycleOrderID => {
			return await Axios.get(GET_CYCLE_PURCHASE_DETAIL_API(cycleOrderID));
		},
		// eslint-disable-next-line
		[]
	);

	const getCyclePurchaseDetailHistoryApi = useCallback(
		async params => {
			const { memberID, cycleOrderID } = params;
			return await Axios.get(GET_CYCLE_PURCHASE_DETAIL_HISTORY_API(memberID, cycleOrderID));
		},
		// eslint-disable-next-line
		[]
	);

	const getCyclePurchaseDetailFutureApi = useCallback(
		async params => {
			const { memberID, cycleOrderID } = params;
			return await Axios.get(GET_CYCLE_PURCHASE_DETAIL_FUTURE_API(memberID, cycleOrderID));
		},
		// eslint-disable-next-line
		[]
	);

	const getCyclePurchaseDetailEffectApi = useCallback(
		async params => {
			const { cycleOrderID, effectID } = params;
			return await Axios.get(GET_CYCLE_PURCHASE_DETAIL_EFFECT_API(cycleOrderID, effectID));
		},
		// eslint-disable-next-line
		[]
	);

	const getCyclePurchaseDetailPdfApi = useCallback(
		async params => {
			const { memberID, cycleOrderID } = params;
			return await Axios.get(GET_CYCLE_PURCHASE_DETAIL_PDF_API(memberID, cycleOrderID));
		},
		// eslint-disable-next-line
		[]
	);

	const getCyclePurchaseDetailPdfEffectApi = useCallback(
		async params => {
			const { memberID, effectID } = params;
			return await Axios.get(GET_CYCLE_PURCHASE_DETAIL_PDF_EFFECT_API(memberID, effectID));
		},
		// eslint-disable-next-line
		[]
	);

	return {
		postCyclePurchaseOverviewApi,
		getCyclePurchaseOverviewOptionsApi,
		getCyclePurchaseDetailApi,
		getCyclePurchaseDetailHistoryApi,
		getCyclePurchaseDetailFutureApi,
		getCyclePurchaseDetailEffectApi,
		getCyclePurchaseDetailPdfApi,
		getCyclePurchaseDetailPdfEffectApi,
	};
};

export default useCyclePurchaseOverviewApi;
